/**
 * Bootstrap Firebase config used only for staging to fetch client config from Firestore.
 *
 * Staging: shared project unwontedartistry-stage (clientConfigs/<clientId>).
 * Production: there is no shared production. Each client's config comes from their
 * own Firestore; the app must be built/run with firebase.json (client's project).
 */
import { getApps, initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getEnvironment } from '../utils/environmentDetection';

const environment = getEnvironment();
// Only staging uses a shared project; production never reaches this (index.tsx requires firebase.json).
const platformProjectId =
  environment === 'staging' ? 'unwontedartistry-stage' : 'unwontedartistry-stage';

const bootstrapConfig = {
  apiKey: 'AIzaSyCCliftiUkffeaWLTakt8J8Vc0RCy41zmc',
  authDomain: `${platformProjectId}.firebaseapp.com`,
  projectId: platformProjectId,
  storageBucket: 'unwontedartistry-stage.firebasestorage.app',
  messagingSenderId: '1061678484888',
  appId: '1:1061678484888:web:cba6481e810231adcaefed',
  measurementId: 'G-YYD5HWH45W',
};

// Use the default app (no name) so that firebaseConfig.ts's getApp() gets the same instance
// after bootstrap. If we used a named app here, the rest of the app would see getApps().length > 0
// but getApp() would throw "No Firebase App '[DEFAULT]' has been created".
export function getBootstrapFirestore(): ReturnType<typeof getFirestore> {
  const apps = getApps();
  const app = apps.length > 0 ? apps[0]! : initializeApp(bootstrapConfig);
  return getFirestore(app);
}
